import { render } from "./keyMove.vue?vue&type=template&id=34acc6c4&scoped=true"
import script from "./keyMove.vue?vue&type=script&lang=js"
export * from "./keyMove.vue?vue&type=script&lang=js"

import "./keyMove.vue?vue&type=style&index=0&id=34acc6c4&scoped=true&lang=css"

import exportComponent from "G:\\phpstudy_pro\\WWW\\xsr SYETEM\\vue-webagent\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34acc6c4"]])

export default __exports__